export enum Variant {
    Default = 'default',
    Costs = 'costs',
}
export interface RoundtripOfferTravellers {
    adults: number;
    children: number;
}

export interface RoundtripOfferViewModel {
    uri: string;
    price: {
        amount: number;
        formattedString: string;
        formattedStringWithCurrency: string;
        bestPrice: boolean;
        currency: string;
    };
    travellers: RoundtripOfferTravellers;
    startDate: string;
    endDate: string;
    duration: number; //duration in days
}

export interface OpeningHour {
    weekday: number;
    morningStart: string;
    morningEnd: string;
    afternoonStart: string | null;
    afternoonEnd: string | null;
    byAppointment: boolean | null;
}

export interface OpeningHours {
    defaultOpeningHours: OpeningHour[];
}

export interface SalesSiteResponse {
    salesSiteId: string;
    name: string;
    nameShort: string;
    legalName: string;
    city: string;
    websiteUrl: string;
    address: string;
    additionalAddress: string;
    zip: string;
    latitude: number;
    longitude: number;
    phone: string;
    email: string;
    facebookUrl: string;
    instagramUrl: string;
    teamId: string;
    openingHours: OpeningHours;
}
